import get from 'lodash/get'
import { sprintf } from 'sprintf-js'

import messages, { type MessageId } from '@/translations/messages'
import type { PlainObject } from '@/types'

export const getMessage = (path: MessageId, values?: PlainObject) => {
  const rawMessage = get(messages, path, Error(`could not find path provided to getMessage: ${path}`))
  if (rawMessage instanceof Error) {
    throw rawMessage
  }
  // @TODO look for solution for pluralizing similiar to format.js
  if (values && typeof values.pluralize === 'number') {
    return sprintf(rawMessage, values.pluralize === 1 ? '' : 's', values.pluralize === 1 ? 's' : '')
  }
  return sprintf(rawMessage, values)
}

export default {}
